import React, { useEffect, useState } from "react";
import s from './questions.module.css';
import { useNavigate } from "react-router-dom";


export default function Questions() {
	const navigate = useNavigate();
	
	
	useEffect(() => {
		//fetchData();
	}, []);
	
	return (
		<div className={s.container}>
		
			<div>
				<div>Summary</div>
				<div style={{"marginBottom":"20px"}}>
					<div>30: MC (weakness)</div>
					<div className={s.qtnHolder_div}>
						<div>
							<div className={s.label_div}>Question:</div>
							<div className={s.text_input}>Now choose the best name for the story:</div>
						</div>
						
						<div>
							<div className={s.label_div}>Answer:</div>
							<div className={s.text_input}>A Day of Betty</div>
						</div>
						
						<div>
							<div className={s.label_div}>Wks ids: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
								<div className={s.text_input}>Max 3 wks</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
								
							</div>
						</div>
						<div>
							<div className={s.label_div}>Other Options: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>Breakfast with Betty</div>
									<div style={{"width":"80px","marginLeft":"10px"}}>weakness:</div><div className={s.text_input}>Max 3 wks</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>Betty's favourite football team</div>
									<div style={{"width":"80px","marginLeft":"10px"}}>weakness:</div><div className={s.text_input}>Max 3 wks</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div style={{"marginBottom":"20px"}}>
					<div>31: word explanation (word + meaning)</div>
					
					<div className={s.qtnHolder_div}>
						<div>
							<div className={s.label_div}>Sentence:</div>
							<div className={s.text_input}>A place where water falls from a high place making a loud noise.</div>
						</div>
						<div>
							<div className={s.label_div}>Answer:</div>
							<div className={s.text_input}>Waterfall/something else</div>
						</div>
						<div>
							<div className={s.label_div}>Word ids: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
								<div className={s.text_input}>Max 3 words</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
								
							</div>
						</div>
						<div>
							<div className={s.label_div}>Other Options: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>restaurant</div>
									<div style={{"width":"80px","marginLeft":"10px"}}>word:</div><div className={s.text_input}>Max 3 words</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>skyscraper</div>
									<div style={{"width":"80px","marginLeft":"10px"}}>word:</div><div className={s.text_input}>Max 3 words</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				
				<div style={{"marginBottom":"20px"}}>
					<div>32: dropdown box (words)</div>
					
					<div className={s.qtnHolder_div}>
						<div>
							<div className={s.label_div}>First Sentence:</div>
							<div className={s.text_input}>watch a match at their </div>
						</div>
						<div>
							<div className={s.label_div}>Answer: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
									<div className={s.text_input}>stadium</div>
									<div style={{"width":"80px","marginLeft":"10px"}}>word ids:</div><div className={s.text_input}>Max 3 words</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
								
							</div>
						</div>
						<div>
							<div className={s.label_div}>last Sentence:</div>
							<div className={s.text_input}> one day.</div>
						</div>
						
						<div>
							<div className={s.label_div}>Other Options: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>restaurant</div>
									<div style={{"width":"60px","marginLeft":"10px"}}>word:</div><div className={s.text_input}>Max 3 words</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>skyscraper</div>
									<div style={{"width":"60px","marginLeft":"10px"}}>word:</div><div className={s.text_input}>Max 3 words</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div style={{"marginBottom":"20px"}}>
					<div>33: dropdown box (weakness)</div>
					
					<div className={s.qtnHolder_div}>
						<div>
							<div className={s.label_div}>First Sentence:</div>
							<div className={s.text_input}>Tom and Max in the Park<br/><br/>The park is big and has lots of green grass, trees, and flowers. Kids </div>
						</div>
						<div>
							<div className={s.label_div}>Answer: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
									<div className={s.text_input}>come</div>
									<div style={{"width":"60px","marginLeft":"10px"}}>wks:</div><div className={s.text_input}>Max 3 wks</div><div className={s.text_input}>Present simple tense and subject-verb agreement</div><div className={s.text_input}>...</div>
								</div>
								
							</div>
						</div>
						<div>
							<div className={s.label_div}>last Sentence:</div>
							<div className={s.text_input}>here to play and fly their kites. <br/><br/></div>
						</div>
						
						<div>
							<div className={s.label_div}>Other Options: </div>
							<div className={s.otherOptionHolder_div}>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>comes</div>
									<div style={{"width":"60px","marginLeft":"10px"}}>wks:</div><div className={s.text_input}>Max 3 wks</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
								<div>
									<div style={{"width":"60px"}}>answer:</div><div className={s.text_input}>coming</div>
									<div style={{"width":"60px","marginLeft":"10px"}}>wks:</div><div className={s.text_input}>Max 3 wks</div><div className={s.text_input}>optional</div><div className={s.text_input}>...</div>
								</div>
							</div>
						</div>
					</div>
				</div>


			</div>
		</div>
	);
}
